import { type RefObject, useEffect } from 'react';

type UseFetchNextProductsProps = {
	fetchNextPage: () => Promise<void>;
	hasNextPage: boolean;
	isFetching: boolean;
	listEndRef: RefObject<HTMLDivElement>;
};

export const useFetchNextProducts = ({
	fetchNextPage,
	hasNextPage,
	isFetching,
	listEndRef
}: UseFetchNextProductsProps) => {
	useEffect(() => {
		const target = listEndRef.current;
		const distanceFromEnd = window.innerHeight * 0.5;

		const options = {
			rootMargin: `${distanceFromEnd}px`,
			threshold: 1
		};

		const handleIntersect: IntersectionObserverCallback = entries => {
			const [entry] = entries;

			if (entry?.target === target && entry?.isIntersecting) {
				if (hasNextPage && !isFetching) fetchNextPage();
			}
		};

		const observer = new IntersectionObserver(handleIntersect, options);

		target && observer.observe(target);

		return () => {
			target && observer.unobserve(target);
		};
	}, [fetchNextPage, hasNextPage, isFetching]);
};
